import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import SVG from 'components/icons/SVG';
import styles from './styles.module.scss';

function ButtonShowPassword(props) {
  const { t } = useTranslation();
  return (
    <button
      id={props.id}
      className={styles.passwordButton}
      onClick={props.onClick}
      tabIndex={-1}
      type="button"
      title={t('common_show_hide_pw')}>
      <div className={styles.iconContainer}>
        <SVG icon="eye" styles={[styles.icon]} />
      </div>
    </button>
  );
}

ButtonShowPassword.propTypes = {
  id: PropTypes.string,
  onClick: PropTypes.func.isRequired
};

ButtonShowPassword.defaultProps = {
  id: undefined
};

export default ButtonShowPassword;
